export const WaterSensor = {
    source: require('./WaterSensor.png'),
    alt: 'The HomeMetrics Water Sensor'
};